import { Skeleton } from 'antd';
import { Container } from './BaseCard.styled';

export default function BaseCard(props) {
  return <Container {...props} />;
}

BaseCard.Skeleton = function BaseCardSkeleton() {
  return (
    <BaseCard clickable={false}>
      <Skeleton active paragraph={{ rows: 1 }} />
    </BaseCard>
  );
};
